import React, { useRef, useState } from 'react';

const Menu = ({ element, close, changeText }) => {

    const submenuRef = useRef(null); // Ссылка на новое меню
    const [isSubmenuOpen, setSubmenuOpen] = useState(false); // Состояние открытия нового меню

    document.addEventListener("click", () => {
        close();
    });

    function selectAll(e) {
        e.target.select();
    }

    function copy() {
        navigator.clipboard.writeText(window.getSelection().toString());
    }

    function paste(e) {
        let firstText = e.target.value.slice(0, e.target.selectionStart);
        let secondText = e.target.value.slice(e.target.selectionEnd, e.target.value.length);
        navigator.clipboard.readText().then((data) => {
            e.target.value = firstText + data + secondText;
            changeText(e);
        });
    }
    function pastFormula(formula,e) {
        let firstText = e.target.value.slice(0, e.target.selectionStart);
        let secondText = e.target.value.slice(e.target.selectionEnd, e.target.value.length);
            e.target.value = firstText + formula + secondText;
        changeText(e)
    }
    function handleSubmenuOpen() {
        setSubmenuOpen(true);
    }

    function handleSubmenuClose() {
        setSubmenuOpen(false);
    }

    const submenuStyle = {
        position: 'fixed',
        top: element.clientY-20,
        left: element.clientX+117.488,
    };

    return (
        <div className="taskcr-txt-context" style={{ position: 'fixed', top: element.clientY, left: element.clientX }}>
            <div className="taskcr-txt-context-item"><button onClick={() => { selectAll(element) }}>Выделить всё</button></div>
            <div className="taskcr-txt-context-item"><button onClick={() => { copy() }}>Копировать</button></div>
            <div className="taskcr-txt-context-item"><button onClick={() => { paste(element) }}>Вставить</button></div>
            <hr />
            <div
                className="taskcr-txt-context-item"
                onMouseOver={handleSubmenuOpen}
                onMouseLeave={handleSubmenuClose}
            >
                <button>Формулы</button>
                {isSubmenuOpen && (
                    <div ref={submenuRef} style={submenuStyle} className="taskcr-txt-context">
                        <div style={{display:'flex',justifyContent: 'space-around'}}>
                            <div className="taskcr-txt-context-item" onClick={()=>pastFormula('√(',element)}><button>&#8730;</button></div>  {/* корень */}
                            <div className="taskcr-txt-context-item" onClick={()=>pastFormula('∞',element)}><button>&#8734;</button></div>  {/* бесконечность */}
                            <div className="taskcr-txt-context-item" onClick={()=>pastFormula('°',element)}><button>&#176;</button></div>  {/* градус */}
                            <div className="taskcr-txt-context-item" onClick={()=>pastFormula('∑',element)}><button>&#8721;</button></div>  {/* сумма */}
                        </div>
                        <hr/>
                        <div style={{display:'flex',justifyContent: 'space-around'}}>
                            <div>
                                <div  className="taskcr-txt-context-item" onClick={()=>pastFormula('>',element)}><button>&#62;</button></div>  {/* больше */}
                                <div  className="taskcr-txt-context-item" onClick={()=>pastFormula('≥',element)}><button>&#8805;</button></div>  {/* больше или равно */}
                            </div>
                            <div>
                                <div  className="taskcr-txt-context-item" onClick={()=>pastFormula('<',element)}><button>&#60;</button></div>  {/* меньше */}
                                <div  className="taskcr-txt-context-item" onClick={()=>pastFormula('≤',element)}><button>&#8804;</button></div>  {/* меньше или равно */}
                            </div>
                            <div>
                                <div  className="taskcr-txt-context-item" onClick={()=>pastFormula('≈',element)}><button>&#8776;</button></div>  {/* примерно равно */}
                                <div  className="taskcr-txt-context-item" onClick={()=>pastFormula('±',element)}><button>&#177;</button></div>  {/* плюс минус */}
                            </div>
                        </div>
                        <hr/>
                        <div  style={{display:'flex',justifyContent: 'space-around'}}>
                            <div className="taskcr-txt-context-item" onClick={()=>pastFormula('²',element)}><button>x&sup2;</button></div>  {/* х во втрой */}
                            <div className="taskcr-txt-context-item" onClick={()=>pastFormula('³',element)}><button>x&sup3;</button></div>  {/* х в третей */}
                            <div className="taskcr-txt-context-item" onClick={()=>pastFormula('^(',element)}><button>x^n</button></div>  {/* х во n */}
                        </div>
                        <hr/>
                        <div style={{display:'flex',justifyContent: 'space-around'}}>
                            <div className="taskcr-txt-context-item" onClick={()=>pastFormula('sin(',element)}> <button>sin</button></div>  {/* синус */}
                            <div className="taskcr-txt-context-item" onClick={()=>pastFormula('cos(',element)}><button>cos</button></div>  {/* косинус */}
                            <div className="taskcr-txt-context-item" onClick={()=>pastFormula('tg(',element)}><button>tg</button></div>  {/* тангенс*/}
                            <div className="taskcr-txt-context-item" onClick={()=>pastFormula('ctg(',element)}><button>ctg</button></div>  {/* котангенс */}
                        </div>
                        <hr/>
                        <div className="taskcr-txt-context-item" onClick={()=>pastFormula('π',element)}><button>&pi;</button></div>  {/* пи */}

                    </div>
                )}
            </div>
            <hr />
        </div>
    );
};

export default Menu;
